export const GET_DATA_START = '@flights/GET_DATA_START'
export const GET_DATA_SUCCESS = '@flights/GET_DATA_SUCCESS'
export const GET_DATA_FAILURE = '@flights/GET_DATA_FAILURE'



// WEBPACK FOOTER //
// ./src/screens/flights/actions/types.js